export class CurrencyPosition {
  currency: string;
  cashPosition: number;
  tradePosition: number;
  netEquityPosition: number;
  netEquityCacPosition: number;
  netOpenPosition: number;
  bitfinexPosition: number;

  constructor(currency: string) {
    this.currency = currency;
  }
}
